<template>
  <b-card>
    <b-row>
      <b-col sm="10">
        <h3 tabindex="0">Consultar Conferências</h3>
      </b-col>
      <b-col sm="2">
        <b-button @click="navigate('/conferencias/cadastrar/-1')" block variant="primary">
            <i class="fa fa-plus"></i>
            <span>Nova Conferência</span>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group label="Nome da Conferência:">
          <b-form-input type="text" id="name" v-model="filtro.nome"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="4">
        <b-form-group label="Status:">
          <b-form-radio-group v-model="filtro.status" :options="status"/>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="Área:">
          <b-form-select v-model="filtro.area_id">
             <option :value="null" selected> Selecione </option>
             <option v-for="item in areas" :key="item.id" :value="item.id"> {{item.titulo}}</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2">
        <b-button block @click="limpar">
          <i class="fa fa-eraser"></i>&nbsp;&nbsp;<span>Limpar filtros</span>
        </b-button>
      </b-col>
      <b-col sm="2">
        <b-button block variant="primary" @click="carregar">
          <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
        </b-button>
      </b-col>
    </b-row>
    <b-row><b-col>&nbsp;</b-col></b-row>
    <b-row>
      <b-col>
        <b-table id="conferencias" :fields="campos" :items="conferencias" :per-page="totalPorPagina" :current-page="paginaAtual" small bordered outlined>
          <template #cell(status)="data">{{data.item.status ? 'Ativo' : 'Inativo'}}</template>
          <template #cell(id)="data">
            <b-row no-gutters>
              <b-col>
                <b-row no-gutters align-h="end">
                  <b-link title="Visualizar" @click="navigate('/conferencias/visualizar/' + data.item.id)">
                    <i class="fa fa-search" style="color: black"/>
                  </b-link>&nbsp;
                  <b-link title="Editar" @click="navigate('/conferencias/editar/' + data.item.id)">
                    <i class="fa fa-edit" style="color: black"/>
                  </b-link>&nbsp;
                  <b-link title="Excluir" @click="remover(data.item.id)">
                    <i class="fa fa-times" style="color: black"/>
                  </b-link>
                </b-row>
              </b-col>
              <b-col>
                <b-form-checkbox v-model="data.item.status" @change="alternar(data.item.id)" v-b-popover.hover.right="data.item.status ? 'Desativar' : 'Ativar'" switch style="width:45px"/>
              </b-col>
            </b-row>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col><b-pagination v-model="paginaAtual" :total-rows="conferencias.length" :per-page="totalPorPagina" aria-controls="conferencias" v-show="conferencias.length > 0"/></b-col>
    </b-row>
    <b-row>
      <b-col>Exibindo página {{paginaAtual}} de {{Math.floor(conferencias.length / totalPorPagina) + (conferencias.length % totalPorPagina > 0 ? 1 : 0)}}, total de {{conferencias.length}} registro{{conferencias.length > 1 ? 's' : ''}}.</b-col>
    </b-row>
  </b-card>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  created () {
    this.$store.dispatch('getAreasAtivas')
  },
  data () {
    return {
      totalPorPagina: 10,
      paginaAtual: 1,
      filtro: {
        nome: null,
        status: null,
        area_id: null
      },
      status: [
        {value: true, text: 'Ativo'},
        {value: false, text: 'Inativo'}
      ],
      campos: [
        {key: 'nome', label: 'Nome da Conferência', sortable: true},
        {key: 'area_titulo', label: 'Área', sortable: true},
        {key: 'status', label: 'Status', sortable: false},
        {key: 'id', label: 'Ações', sortable: false, tdClass: 'centro', thClass: 'centro'}
      ],
      conferencias: []
    }
  },
  computed: {
    ...mapState({
      mensagemConferencia: state => state.conferencia.mensagem,
      areas: state => state.area.lista
    })
  },
  mounted () {
    if (this.mensagemConferencia) {
      this.sucesso(this.mensagemConferencia)
      this.$store.commit('setMensagemConferencia', null)
    }

    this.carregar()
  },
  methods: {
    carregar () {
      Vue.http.post('api/conferencia/buscar', this.filtro).then(response => {
        if (response.body.success) {
          this.conferencias = response.body.data
        }
      })
    },
    navigate (route) {
      this.$router.push(route)
    },
    sucesso (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Sucesso',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'info'
      })
    },
    erro (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Erro',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'danger'
      })
    },
    alternar (id) {
      let index = -1

      for (let i = 0; i < this.conferencias.length && index === -1; i++) {
        index = this.conferencias[i].id === id ? i : -1
      }

      let mensagem = this.conferencias[index].status ? 'Tem certeza que deseja ativar este registro?' : 'Tem certeza que deseja desativar este registro?'

      this.$bvModal.msgBoxConfirm(mensagem, {
        noCloseOnBackdrop: true,
        centered: true,
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          if (this.conferencias[index].status === false && this.conferencias[index].vinculos.length > 0) {
            this.conferencias[index].status = !this.conferencias[index].status
            this.erro('O registro que se deseja inativar já está vinculado a outras entidades do sistema.')
          } else {
            Vue.http.get('api/conferencia/switch/' + id)

            if (this.conferencias[index].status) {
              this.sucesso('Conferência ativada com sucesso.')
            } else {
              this.sucesso('Conferência desativada com sucesso.')
            }
          }
        } else {
          this.conferencias[index].status = !this.conferencias[index].status
        }
      })
    },
    remover (id) {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja excluir este registro?', {
        noCloseOnBackdrop: true,
        centered: true,
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          let index = -1

          for (let i = 0; i < this.conferencias.length && index === -1; i++) {
            index = this.conferencias[i].id === id ? i : -1
          }

          if (this.conferencias[index].vinculos.length > 0) {
            this.erro('O registro que se deseja excluir já está vinculado a outras entidades do sistema.')
          } else {
            Vue.http.get('api/conferencia/remover/' + id).then(response => {
              if (response.body.success) {
                this.carregar()
                this.sucesso('Conferência removida com sucesso!')
              }
            })
          }
        }
      })
    },
    limpar () {
      this.filtro = {nome: null, status: null}
      this.carregar()
    }
  }
}
</script>

<style>
  .centro {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/conferencia/Consultar.vue